import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface OptionProps {
  disabled?: boolean;
  height?: number;
  shadow?: boolean;
}

const ITEM_HEIGHT = 44;

const Option = styled.div<OptionProps>`
  display: flex;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${({ height }) => (height ? toRem(height) : toRem(ITEM_HEIGHT))};
  padding: ${toRem(5.5)};
  background-color: ${theme.color.white};
  color: ${theme.color.neutral[900]};
  cursor: pointer;
  box-shadow: ${({ shadow }) => shadow && `inset 0px -1px 0px ${theme.color.neutral[300]}`};

  div {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 ${toRem(11)};
    border-radius: ${toRem(5.5)};
    background-color: transparent;
  }

  &:hover {
    div {
      background-color: ${theme.color.neutral[50]};
    }
  }

  &.active {
    div {
      background-color: ${theme.color.neutral[50]};
      font-weight: ${theme.font.weight.medium};
    }
  }

  &:focus {
    div {
      border-color: rgba(0, 0, 0, 0.055);
      outline: none;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.color.neutral[400]};
      cursor: default;

      &:hover {
        div {
          background-color: ${theme.color.white};
          color: ${theme.color.neutral[400]};
        }
      }
    `}
`;

export default Option;
